import React, { useState, useEffect } from 'react'; 
import axios from 'axios'; 
import { ToastContainer, toast } from 'react-toastify'; 
import 'react-toastify/dist/ReactToastify.css'; 
import * as XLSX from 'xlsx'; 
import { saveAs } from 'file-saver';
import { useShop } from '../context/ShopContext';
import { FaSpinner } from 'react-icons/fa';
import EmptyState from "./EmptyState";
import Sidebar from './Sidebar';


const Salesreport = () => {
  const [stockData, setStockData] = useState(null); // Initial state is null (no data fetched yet)
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [fromDate, setFromDate] = useState('');
  const [toDate, setToDate] = useState('');
  const [isDataFetched, setIsDataFetched] = useState(false);
 
  const [entriesPerPage, setEntriesPerPage] = useState(10); 
  const [currentPage, setCurrentPage] = useState(1); 
  const { shopName, shopId, userId , companyId } = useShop();
  console.log("shopid",shopId)
  console.log("companyid:",companyId)










  

  const showToast = (message, type = "error") => {
    toast.dismiss(); // Dismiss any existing toast before showing a new one
  
    console.log("Toast Type:", type); // Debugging log to check type value
  
    if (type.toLowerCase() === "error") {
      toast.error(message);
    } else if (type.toLowerCase() === "success") {
      toast.success(message);
    } else {
      console.warn("Invalid toast type:", type);
    }
  };
  

  useEffect(() => {
    const today = new Date().toISOString().split('T')[0]; 
    setFromDate(today);
    setToDate(today);
  }, []);

  const fetchStockData = async () => {
    setLoading(true);
    setError(null);

   

    try {
      const response = await axios.post(
        'https://winenew.sipstocks.in/api/Liquor/GetSalesAmount',
        {
          shopId: shopId,
          fromDate: new Date(fromDate).toISOString(),
          toDate: new Date(toDate).toISOString(),
          companyId: companyId,
        },
        {
          headers: {
            Accept: '*/*',
            'Content-Type': 'application/json',
          },
        }
      );

      console.log("SalesReport data in report :", response);
      if (response.data && response.data.data) {
        setStockData(response.data.data);
        setIsDataFetched(true); // <-- Enable export
      } else {
        setStockData([]); // Set stockData as an empty array if no data is returned
        setIsDataFetched(false); // <-- Disable export
      }
    } catch (err) {
      console.error('Error fetching stock data:', err);
      setError('Failed to fetch stock data. Please try again later.');
    } finally {
      setLoading(false);
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!fromDate || !toDate) {
      setError('Please select both from and to dates.');
      return;
    }
    fetchStockData(); // Call API on button click
  };

  const exportToExcel = () => {
    if (!stockData || stockData.length === 0) {
      showToast("No data to export!","error");
      return;
    }
  
    try {
      const exportData = stockData.map((item, index) => ({
        "S.No.": index + 1,
        "Sales Date": new Date(item.salesDate).toLocaleDateString(),
        "अंग्रेज़ी":parseFloat(item.english) || 0,
        "देसी":parseFloat(item.desi) || 0,
        "Total Net Sales":parseFloat(item.sales) || 0,
        "Total exp": parseFloat(item.exp) || 0,
        "Debit": parseFloat(item.debit) || 0,
        "Credit": parseFloat(item.credit) || 0,
        "Salary": parseFloat(item.salary) || 0,
        "Commission": parseFloat(item.commissionValue) || 0,
      
        "R.D.Credit" : parseFloat(item.rdCredit) || 0,
        "R.D. Debit" : parseFloat(item.rdDebit) || 0,
       
        "Phonepay Credit":parseFloat(item.pPayCredit) || 0,
        "In hand Cash": parseFloat(item.amount) || 0,
      }));
  
    
     
      const totalEnglish = stockData.reduce((sum, item) => sum + (parseFloat(item.english) || 0), 0);
      const totalDesi = stockData.reduce((sum, item) => sum + (parseFloat(item.desi) || 0), 0);
      const totalSales = stockData.reduce((sum, item) => sum + (parseFloat(item.sales) || 0), 0);
      const totalexp = stockData.reduce((sum, item) => sum + (parseFloat(item.exp) || 0), 0);
      const totalDebit = stockData.reduce((sum, item) => sum + (parseFloat(item.debit) || 0), 0);
         
      const totalCredit = stockData.reduce((sum, item) => sum + (parseFloat(item.credit) || 0), 0);
      const totalSalary = stockData.reduce((sum, item) => sum + (parseFloat(item.salary) || 0), 0);
      const totalComissionValue = stockData.reduce((sum, item) => sum + (parseFloat(item.commissionValue) || 0), 0);
   
      const totalRDcredit = stockData.reduce((sum, item) => sum + (parseFloat(item.rdCredit) || 0), 0);
      const totalRDdebit = stockData.reduce((sum, item) => sum + (parseFloat(item.rdDebit) || 0), 0);
      const totalPhonepaycredit = stockData.reduce((sum, item) => sum + (parseFloat(item.pPayCredit) || 0), 0);
      const totalAmount = stockData.reduce((sum, item) => sum + (parseFloat(item.amount) || 0), 0);
 
     
 
   
   
  
   
   
    
     
  
 
      exportData.push({
        "S.No.": "Total",
        "Sales Date": "",
        "अंग्रेज़ी":totalEnglish.toFixed(2),
        "देसी":totalDesi.toFixed(2),
        "Total Net Sales":totalSales.toFixed(2),
        "Total exp":totalexp.toFixed(2),
        "Debit":totalDebit.toFixed(2),
        "Credit":totalCredit.toFixed(2),
        "Salary":totalSalary.toFixed(2),
        "Commission":totalComissionValue.toFixed(2),
      
        "R.D. Credit" : totalRDcredit.toFixed(2),
        "R.D. debit" : totalRDdebit.toFixed(2),
        "R.D. PhonepayCredit" : totalPhonepaycredit.toFixed(2),
        "In hand Cash": totalAmount.toFixed(2),
      
     
        
      });
  
      const worksheet = XLSX.utils.json_to_sheet(exportData);
      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, worksheet, "Sales Report");
  
      const excelBuffer = XLSX.write(workbook, { bookType: "xlsx", type: "array" });
      const data = new Blob([excelBuffer], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });
  
      saveAs(data, "Sales_Report.xlsx");
      showToast("Data exported successfully!","success");
      setTimeout(() => window.location.reload(), 2000);
    } catch (error) {
      console.error("Error exporting data:", error);
      showToast("Failed to export data.","error");
    }
  };
  
  
  

  const handleEntriesPerPageChange = (e) => {
    setEntriesPerPage(Number(e.target.value));
    setCurrentPage(1); // Reset to the first page when the entries per page is changed
  };

  const paginateData = () => {
    const startIndex = (currentPage - 1) * entriesPerPage;
    const endIndex = startIndex + entriesPerPage;
    return stockData.slice(startIndex, endIndex);
  };

  const totalPages = Math.ceil(stockData ? stockData.length / entriesPerPage : 0);

  return (
      <div className="app-main flex-column flex-row-fluid" id="kt_app_main">
          {/* Content wrapper */}
          <div className="d-flex flex-column flex-column-fluid">
              {/* Toolbar */}
              <div id="kt_app_toolbar" className="app-toolbar py-3 py-lg-6">
                  {/* Toolbar container */}
                  <div id="kt_app_toolbar_container" className="app-container container-fluid d-flex flex-stack">
                      {/* Page title */}
                      <div className="page-title d-flex flex-column justify-content-center flex-wrap me-3">
                          {/* Title */}
                          <h1 className="page-heading d-flex text-gray-900 fw-bold fs-3 flex-column justify-content-center my-0">
                          Sales Report
                          </h1>
                          <ul className="breadcrumb breadcrumb-separatorless fw-semibold fs-7 my-0 pt-1">
                              <li className="breadcrumb-item text-muted">
                                  <a href="index.html" className="text-muted text-hover-primary">Home</a>
                              </li>
                              <li className="breadcrumb-item">
                                  <span className="bullet bg-gray-500 w-5px h-2px"></span>
                              </li>
                              <li className="breadcrumb-item text-muted">Dashboards</li>
                          </ul>
                      </div>
                  </div>
              </div>
        
              <div id="kt_app_content" className="app-content flex-column-fluid">
                  <div id="kt_app_content_container" className="app-container container-fluid">
                      <div className="row g-5 g-xl-10 mb-5 mb-xl-10">
                          <div className="col-xl-12">
                             
                                   <ToastContainer />
                                
                                  <div className="card-body ">
                                      <div className="table-responsive">
                                          <div className="panel-body">
                                      





                   
                                          <div className="col-lg-12 col-md-6 col-sm-12 col-xs-12">
                                            <form onSubmit={handleSubmit} style={{ marginBottom: '20px' }}>
                                            <div className="form-group row align-items-center">
                                               <div className="col-lg-2 col-6">
                                               <label htmlFor="fromDate" className="form-label">
                                                From Date:
                                                  </label>
                                                <input
                                                  type="date"
                                                  className="form-control"
                                                  value={fromDate}
                                                  onChange={(e) => setFromDate(e.target.value)}
                                                   />
                                          </div>
                                        <div className="col-lg-2 col-6">
                                         <label htmlFor="toDate" className="form-label">
                                           To Date:
                                         </label>
                                    <input
                            type="date"
                            className="form-control"
                            value={toDate}
                            onChange={(e) => setToDate(e.target.value)}
                          />
    </div>
   
 
    <div className="col-lg-2 col-12 mt-3">
      <button type="submit" className="btn btn-primary mt-5">
        +GETDATA
      </button>
    </div>
  </div>
  </form>
</div>
  
                     
                                              <div className="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                                                  <form className="form-inline">
                                                      <div className="form-group">

                                                      
                                                        
                                                      </div>
     
                                                  </form>
                                              </div>
                                              <div className="clearfix"></div>
                                              <br />
                                              {error && <p style={{ color: "red" }}>Failed to fetch data.</p>}

{stockData === null && !loading && (
  <div style={{ textAlign: 'Left', fontSize: '18px', fontWeight: 'bold' }}>
   
  </div>
)}

{!loading && stockData && stockData.length === 0 && <EmptyState />}

{!loading && stockData && stockData.length > 0 && (
  <div>
     
            <div className="table-responsive mt-4 h-400px">
        
                                            <table className="table table-bordered table-striped">
                                            <thead>
                                              <tr>
                                                <th>S.No.</th>
                                                <th>Date</th>
                                                <th>अंग्रेज़ी</th> 
                                                <th>देसी</th> 
                                                <th> Total Net Sales</th>
                                                <th>Total Exp.</th>
                                                <th>Debit</th>
                                                <th>Credit</th>
                                                    
                                                <th>Salary</th>
                                             
                                                <th>Commission</th>
                                                <th>R.D. Credit</th>
                                                <th>R.D. Debit</th>
                                                <th>Phonepay Credit</th>
                                             
                                           
                                                <th>In hand Cash</th>
                                             
                                              
                                                
                                              </tr>
                                            </thead>
                                            <tbody>
                                              {stockData.map((item, index) => (
                                                <tr key={index}>
                                                  <td>{index + 1}</td>
                                                  <td>{item.salesDate.split("T")[0].split("-").reverse().join("-")}</td>
                                                  <td>₹{item.english}</td>
                                                  <td>₹{item.desi}</td>
                                                  <td>₹{item.sales}</td>
                                                  <td>₹{item.exp}</td>
                                                  <td>₹{item.debit}</td>
                                                  <td>₹{(item.credit)}</td>
                                                  <td>₹{item.salary}</td>
                                               
                                                  <td>₹{(item.commissionValue)}</td>
                                                  <td>₹{item.rdCredit}</td>
                                                  <td>₹{item.rdDebit}</td>
                                                  <td>₹{item.pPayCredit}</td>
                                               
                                               
                                                 
                                                
                                              
                                                  <td>₹{item.amount}</td>
                                              
                                               
                                                 
                                                </tr>
                                              ))}
                                            </tbody>
                                            <tfoot>
                                              <tr>
                                                <td colSpan="2"><strong>Total</strong></td>
                                                <td><strong>₹{stockData.reduce((sum, item) => sum + parseFloat(item.english), 0).toFixed(2)}</strong></td>
                                                <td><strong>₹{stockData.reduce((sum, item) => sum + parseFloat(item.desi), 0).toFixed(2)}</strong></td>
                                                <td><strong>₹{stockData.reduce((sum, item) => sum + item.sales, 0)}</strong></td>
                                                <td><strong>₹{stockData.reduce((sum, item) => sum + item.exp, 0)}</strong></td>
                                                <td><strong>₹{stockData.reduce((sum, item) => sum + item.debit, 0)}</strong></td>
                                                <td><strong>₹{stockData.reduce((sum, item) => sum + item.credit, 0)}</strong></td>
                                                <td><strong>₹{stockData.reduce((sum, item) => sum + item.salary, 0)}</strong></td>
                                              
                                                <td><strong>₹{stockData.reduce((sum, item) => sum + parseFloat(item.commissionValue), 0).toFixed(2)}</strong></td>
                                                <td><strong>₹{stockData.reduce((sum, item) => sum + item.rdCredit, 0)}</strong></td>
                                                <td><strong>₹{stockData.reduce((sum, item) => sum + item.rdDebit, 0)}</strong></td>
                                                <td><strong>₹{stockData.reduce((sum, item) => sum + item.pPayCredit, 0)}</strong></td>
                                               
                                            
                                              
                                            
                                                <td><strong>₹{stockData.reduce((sum, item) => sum + parseFloat(item.amount), 0).toFixed(2)}</strong></td>
                                               
                                              
                                                
                                              </tr>
                                            </tfoot>
                                          </table>
   
    </div>
    
                                   
<div className="d-flex justify-content-between align-items-center mt-4 mb-4">
  {/* Pagination Controls */}
  <div>
    <button
      onClick={() => setCurrentPage(currentPage - 1)}
      disabled={currentPage === 1}
      className="btn btn-secondary me-2"
    >
      Previous
    </button>
    <span className="me-2">
      Page {currentPage} of {totalPages}
    </span>
    <button
      onClick={() => setCurrentPage(currentPage + 1)}
      disabled={currentPage === totalPages}
      className="btn btn-secondary"
    >
      Next
    </button>
  </div>

  {/* Export Button */}
  <button
    onClick={exportToExcel}
    className="btn btn-success"
    disabled={!isDataFetched || (stockData && stockData.length === 0)}
  >
    Export to Excel
  </button>
</div>

                             
   
       
      
      
                                                
                                          </div>
                                               )}
                                          
                                      </div>
                                  </div>
                              </div>
                       
                      </div>
                  </div>
              </div>
          </div>
        
          {/* Footer */}
          <div id="kt_app_footer" className="app-footer">
              <div className="app-container container-fluid d-flex flex-column flex-md-row flex-center flex-md-stack py-3">
                  <div className="text-gray-900 order-2 order-md-1">
                      <span className="text-muted fw-semibold me-1">2025&copy;</span>
                      <a href="#" target="_blank" className="text-gray-800 text-hover-primary">WineShop</a>
                  </div>
              </div>
          </div>
      
        
        
        
        
        
        
        
    
        
       
        
        
        
        
        
       
        
      
        </div>
        </div>
  );
};

export default Salesreport;



